<template>
  <div class="document-attachment-container">
    <DocumentAttachmentItem
      v-for="(documentAttachment, index) in documentAttachments"
      :id="documentAttachment.id"
      :key="documentAttachment.id"
      :data-external="`sign-attachment-${index}`"
      :document-attachment="documentAttachment"
      :focused-required-id="focusedRequiredId"
      :theme="theme"
      :is-signed="isSigned"
      :is-preview="isPreview"
      @uploadFile="handleUploadAttachment"
      @attachmentView="handleAttachmentView"
    />
  </div>
</template>
<script lang="ts">
import type { DocumentAttachment } from '@getaccept/lib-shared/src/types/document-attachment';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import DocumentAttachmentItem from './DocumentAttachmentItem.vue';

export default defineComponent({
  components: {
    DocumentAttachmentItem,
  },
  props: {
    documentAttachments: { type: Array as PropType<DocumentAttachment[]>, required: true },
    focusedRequiredId: { type: String, default: '' },
    theme: { type: Object as PropType<SigningTheme>, default: undefined },
    isSigned: { type: Boolean, default: false },
    isPreview: { type: Boolean, default: false },
  },
  emits: ['uploadFile', 'attachmentView'],
  setup(_, { emit }) {
    const handleUploadAttachment = (payload: { attachmentId: string; name: string }) => {
      emit('uploadFile', payload);
    };
    const handleAttachmentView = (id: string) => {
      emit('attachmentView', id);
    };

    return {
      handleUploadAttachment,
      handleAttachmentView,
    };
  },
});
</script>
